// extracted by mini-css-extract-plugin
export default {"swarmPlot":"SwarmPlot_swarmPlot__zVafn"};